module.exports = __webpack_public_path__ + "static/wind-turbine-4f4a0d1538d128726228f41ddb7ea561.webm";